import { Dialog, IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useState } from "react";
import { font } from "../../../styles/font";
import { theme } from "../../../styles/theme";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ButtonCustom } from "../../button";
import { TextFieldMA } from "../../../styles/styledComponents";
import CancelIcon from "@mui/icons-material/Cancel";
import { HttpStatusCode } from "axios";
import {
  licencePurchase,
  startDemo,
} from "../../../api/controllers/userController";
import { ApplicationContext } from "../../../context/application_ctx";
import { useNavigate } from "react-router-dom";

export const Subscriptions = ({
  setSignInSnack,
  upgrade,
  setLoginNavigation,
  demoExpired,
}) => {
  // context
  const {  setSubscriptionNav,setError } = useContext(ApplicationContext);

  const navigate = useNavigate();
  const { tokenTemp, setClientSecret } = useContext(ApplicationContext);
  const [selectPlan, setSelectPlan] = useState(null);
  const [confimModal, setConfirmModal] = useState(false);
  // const [loaderState, setLoaderState] = useState(false);
  const [noOfEmployees, setNoOfEmployees] = useState(null);
  const [noOfEmployeesChange, setNoOfEmployeesChange] = useState(null);
  let subscriptionCard = [
    {
      planType: "Trial",
      duration: "1-month free trial",
      features: [
        { name: "upto 20 users" },
        { name: "1-month free trail" },
        { name: "1-month free trail" },
        { name: "1-month free trail" },
      ],
      label: "Start trial",
    },
    {
      planType: "Standard",
      duration: "Annually",
      features: [
        { name: "upto 185 users" },
        { name: "1-month free trail" },
        { name: "1-month free trail" },
        { name: "1-month free trail" },
      ],
      label: "Get it now",
    },
  ];

  const handleSubscription = (plans) => {
    setSelectPlan(plans.planType);
    if (plans.planType === "Standard") {
      handleEmployees(plans.planType);
    } else {
      apiSubscribeDemo(plans);
    }
  };

  const handleEmployees = async (selectPlan) => {
    if (!noOfEmployees) {
      setNoOfEmployees("");
    }
    if (selectPlan === "Trial" && noOfEmployees > 2) {
      console.log("apicall");
      apiSubscribeDemo("demo");
    }
    if (selectPlan === "Standard" && noOfEmployees) {
      if (noOfEmployees < 150) {
        apiSubscribeLicence("licence");

        console.log("apicallelse");
      }
      if (noOfEmployees > 150) {
        console.log("opennext");
        setLoginNavigation(4);
      }
    }
  };
  console.log(noOfEmployees, "employyes");
  const apiSubscribeDemo = async (type) => {
    try {
      let response = await startDemo(
        {
          licenseCount: 20,
        },
        tokenTemp
      );
      console.log(response, "responseLogin");
      if (response.status === HttpStatusCode.Ok) {
        // setLoaderState(false);

        setError(response.data.message);
        setSignInSnack(true);
        localStorage.setItem("api-token", tokenTemp);
        setTimeout(() => {
          navigate("/dashboard");
        }, 3000);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        // setLoaderState(false);

        setError(response.data.message);
        setSignInSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const apiSubscribeLicence = async (type) => {
    try {
      let response = await licencePurchase(
        {
          numberOfLicenses: noOfEmployees,
        },
        localStorage.getItem("api-token")
          ? localStorage.getItem("api-token")
          : tokenTemp
      );
      console.log(response, "responseLogin");
      if (response.status === HttpStatusCode.Ok) {
        // setLoaderState(false);
        setClientSecret(response.data.clientSecret);
        if (upgrade) {
          setTimeout(() => {
            //   navigate("/dashboard");
            setSubscriptionNav(true);
          }, 3000);
        } else {
          setError(response.data.message);
          setSignInSnack(true);
          setConfirmModal(false);
          localStorage.setItem("api-token", tokenTemp);
          setTimeout(() => {
            //   navigate("/dashboard");
            setLoginNavigation(4);
          }, 3000);
        }
      }
      if (response.status === HttpStatusCode.BadRequest) {
        // setLoaderState(false);

        setError(response.data.message);
        setSignInSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClose = () => {
    setConfirmModal(false);
    setNoOfEmployeesChange(null);
    setNoOfEmployees(null);
  };

  return (
    <>
      <Box
        display={"flex"}
        width="78%"
        height={"100%"}
        gap="14px"
        overflow="auto"
        flexDirection="column"
        paddingRight="12px"
        alignItems="center"
      >
        <Box
          display={"flex"}
          width="100%"
          // height={"100%"}
          flexDirection="column"
        >
          <Typography
            fontFamily={font.family.fm_2}
            textTransform={"capitalize"}
            fontSize={font.size.fs_2}
            fontWeight="bold"
            color={theme.col_3}
          >
            {upgrade ? "Mindamigo Standard" : " Hey, Welcome to mindamigo"}
          </Typography>
          <Typography
            fontFamily={font.family.fm_2}
            textTransform={"capitalize"}
            fontSize={font.size.fs_5}
            fontWeight="bold"
            color={theme.col_2}
          >
            {demoExpired ? "Hey, Your Trial is expired, please upgrade " : <></>}
          </Typography>
          <Typography
            fontFamily={font.family.fm_2}
            // textTransform={"capitalize"}
            fontSize={font.size.fs_3}
            fontWeight="bold"
            color={theme.col_6}
          >
            {upgrade
              ? "This is our annual plan with all our premium services"
              : "Checkout our plans for your organisation"}
          </Typography>
        </Box>
        <Box
          display={"flex"}
          width="92%"
          gap="30px"
          overflow="auto"
          paddingRight="12px"
          paddingTop="35px"
          justifyContent="center"
          flexWrap="wrap"
        >
          {subscriptionCard.slice(upgrade ? 1 : 0).map((plans, i) => {
            return (
              <>
                <Box
                  display={"flex"}
                  width="201px"
                  minWidth="201px"
                  height={"330px"}
                  //   backgroundColor={theme.col_2_alpha}
                  border={`4px solid ${
                    plans.planType === "Trial" ? theme.col_3 : theme.col_2
                  }`}
                  gap="14px"
                  borderRadius="13px"
                  flexDirection="column"
                  overflow="hidden"
                  padding="10px 10px 10px 10px "
                  // sx={{
                  //   "&:hover": {
                  //     background:
                  //       selectPlan === plans.planType
                  //         ? theme.col_3_alpha
                  //         : theme.col_2_alpha,
                  //   },
                  // }}
                  // backgroundColor='red'
                  // alignItems="center"
                  // justifyContent='center'
                >
                  <Box
                    display={"flex"}
                    paddingBottom="8px"
                    flexDirection="column"
                    borderBottom={`2px solid ${
                      plans.planType === "Trial" ? theme.col_3 : theme.col_2
                    }`}
                    alignItems="flex-start"
                  >
                    <Typography
                      fontFamily={font.family.fm_2}
                      textTransform={"capitalize"}
                      fontSize={font.size.fs_5}
                      fontWeight="bold"
                      color={
                        plans.planType === "Trial" ? theme.col_3 : theme.col_2
                      }
                    >
                      {plans.planType}
                    </Typography>
                    <Typography
                      fontFamily={font.family.fm_2}
                      textTransform={"capitalize"}
                      fontSize={font.size.fs_3}
                      // fontWeight="bold"
                      color={
                        plans.planType === "Trial" ? theme.col_3 : theme.col_2
                      }
                    >
                      {plans.duration}
                    </Typography>
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection="column"
                    // paddingBottom='8px'
                    gap="3px"
                    flex="1"
                  >
                    {plans.features.map((feat, index) => {
                      return (
                        <Box
                          display={"flex"}
                          paddingBottom="8px"
                          gap="10px"
                          alignItems="center"
                        >
                          <CheckCircleIcon
                            sx={{
                              color:
                                plans.planType === "Trial"
                                  ? theme.col_3
                                  : theme.col_2,
                            }}
                          />
                          <Typography
                            fontFamily={font.family.fm_2}
                            textTransform={"capitalize"}
                            fontSize={font.size.fs_3}
                            // fontWeight="bold"
                            color={
                              plans.planType === "Trial"
                                ? theme.col_3
                                : theme.col_2
                            }
                          >
                            {feat.name}
                          </Typography>
                        </Box>
                      );
                    })}
                    <Box
                      display="flex"
                      gap="14px"
                      alignItems="center"
                      flexDirection="column"
                      width="100%"
                      backgroundColor={theme.col_4}
                      flex="1"
                      paddingBottom="16px"
                      justifyContent="flex-end"
                    >
                      {plans.planType === "Standard" ? (
                        <TextFieldMA
                          size="small"
                          required
                          type="number"
                          error={
                            noOfEmployees === null
                              ? false
                              : noOfEmployees === ""
                              ? true
                              : noOfEmployees < 2
                              ? true
                              : false
                          }
                          helperText={
                            noOfEmployees === null
                              ? ""
                              : noOfEmployees === ""
                              ? "No of employees is required"
                              : selectPlan === 0 && noOfEmployees < 2
                              ? "You can choose between 2 to 20 employees"
                              : ""
                          }
                          value={noOfEmployeesChange < 0 ? 0 : noOfEmployeesChange}
                          onBlur={(e) =>
                            setNoOfEmployees(
                              e.target.value < 0 ? 0 : e.target.value
                            )
                          }
                          onChange={(e) =>
                               setNoOfEmployeesChange(
                                  e.target.value < 0 ? 0 : e.target.value
                                )
                          }
                          fullWidth
                          label="Number of Employees"
                        />
                      ) : (
                        ""
                      )}
                      <ButtonCustom
                        onClick={() => handleSubscription(plans)}
                        fullWidth={false}
                        width="100px"
                        height="35px"
                        background={
                          plans.planType === "Trial" ? theme.col_3 : theme.col_2
                        }
                        backgroundRipple={
                          plans.planType === "Trial" ? theme.col_3 : theme.col_2
                        }
                        focusColor={theme.col_1}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        typography={
                          <Typography
                            fontFamily={font.family.fm_2}
                            textTransform={"capitalize"}
                            fontSize={font.size.fs_3}
                            // fontWeight="bold"
                            color={theme.col_4}
                          >
                            {plans.label}
                          </Typography>
                        }
                      />
                    </Box>
                  </Box>
                </Box>
              </>
            );
          })}
        </Box>
        {/* <Box
          display={"flex"}
          width="92%"
          height={upgrade ? "40px" : "90px"}
          gap="30px"
          overflow="auto"
          justifyContent="center"
          alignItems="center"
        >
          <ButtonCustom
            onClick={handleSubscription}
            fullWidth={false}
            disabled={selectPlan === null ? true : false}
            width="100px"
            height="35px"
            // borderRadius="42px"
            // size="large"
            background={theme.col_2}
            backgroundRipple={theme.col_3}
            focusColor={theme.col_1}
            display="flex"
            alignItems="center"
            justifyContent="center"
            typography={
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                // fontWeight="bold"
                color={selectPlan === null ? theme.col_6 : theme.col_4}
              >
                Subscribe
              </Typography>
            }
          />
        </Box> */}
        <Dialog
          open={confimModal}
          fullWidth
          maxWidth={"100%"}
          maxheight={"100%"}
          PaperProps={{
            style: {
              maxHeight: "100%",
              width: "409px",
            },
          }}
          onClose={handleClose}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="13px"
            width="100%"
            backgroundColor={theme.col_4}
          >
            <Box
              display="flex"
              flexDirection="column"
              gap="13px"
              padding="12px 0px 20px 0px"
              width="90%"
              backgroundColor={theme.col_4}
            >
              <Box
                display="flex"
                justifyContent="center"
                width="100%"
                alignItems="center"
              >
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_5}
                  fontWeight="bold"
                  color={theme.col_3}
                  flex="1"
                >
                  {selectPlan}
                </Typography>
                <IconButton onClick={handleClose}>
                  <CancelIcon sx={{ fontSize: "32px", color: theme.col_2 }} />
                </IconButton>
              </Box>
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                textAlign="justify"
                color={theme.col_2}
              >
                Mindamigo provides you 1-month free trial , you can use all the
                mindamigo services for free during this period
              </Typography>
              <Box
                display="flex"
                gap="14px"
                alignItems="center"
                flexDirection="column"
                width="100%"
                backgroundColor={theme.col_4}
              >
                <TextFieldMA
                  size="small"
                  required
                  type="number"
                  error={
                    noOfEmployees === null
                      ? false
                      : noOfEmployees === ""
                      ? true
                      : noOfEmployees < 2
                      ? true
                      : false
                  }
                  helperText={
                    noOfEmployees === null
                      ? ""
                      : noOfEmployees === ""
                      ? "No of employees is required"
                      : selectPlan === 0 && noOfEmployees < 2
                      ? "You can choose between 2 to 20 employees"
                      : ""
                  }
                  value={noOfEmployeesChange}
                  onBlur={(e) =>
                    selectPlan === 0
                      ? setNoOfEmployees(
                          e.target.value < 0 ? 0: e.target.value
                        )
                      : setNoOfEmployees(e.target.value)
                  }
                  onChange={(e) =>
                    selectPlan === 0
                      ? setNoOfEmployeesChange(
                          e.target.value < 0 ? 0: e.target.value
                        )
                      : setNoOfEmployeesChange(e.target.value)
                  }
                  fullWidth
                  label="Number of Employees"
                />
                <ButtonCustom
                  onClick={handleEmployees}
                  fullWidth={false}
                  disabled={false}
                  width="100px"
                  height="35px"
                  // borderRadius="42px"
                  // size="large"
                  background={theme.col_2}
                  backgroundRipple={theme.col_3}
                  focusColor={theme.col_1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  typography={
                    <Typography
                      fontFamily={font.family.fm_2}
                      textTransform={"capitalize"}
                      fontSize={font.size.fs_3}
                      // fontWeight="bold"
                      color={theme.col_4}
                    >
                      confirm
                    </Typography>
                  }
                />
              </Box>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};
